<template>
  <div>
    <b-form-group>
      <label :for="id">{{ label }}</label>
      <validation-provider
        #default="{ errors }"
        :name="errorName"
        :rules="rules"
        :vid="vid"
      >
        <cleave
          :id="id"
          v-model.number="innerValue"
          class="form-control"
          :raw="true"
          :options="options"
          :placeholder="placeholder"
          :disabled="readonly"
          autocomplete="off"
          @input="onInput"
          @keypress.native="handleKeyPress"
          @keydown.native="disableCopyPaste"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { removeSpecialChar, removeNegativeNumber } from '../../helpers/handleSpecialCharacter'

export default {
  name: 'InputNumberField',
  components: {
    BFormGroup,
    ValidationProvider,
    Cleave,
  },
  mixins: [sweetAlert],
  props: {
    label: {
      type: String,
      required: true,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    value: {
      type: null,
      default: '',
    },
    onInput: {
      type: Function,
      default: null,
      required: false,
    },
    vid: {
      type: String,
      default: 'input-number',
    },
    isAllowSpecialCharacters: {
      type: Boolean,
      default: true,
      required: false,
    },
    isAllowCopyAndPaste: {
      type: Boolean,
      default: true,
      required: false,
    },
    isAllowNegativeNumbers: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      innerValue: '',
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    // eslint-disable-next-line consistent-return
    handleKeyPress(event) {
      if (!this.isAllowSpecialCharacters) {
        removeSpecialChar(event)
      }
      if (!this.isAllowNegativeNumbers) {
        removeNegativeNumber(event)
      }
    },
    // eslint-disable-next-line consistent-return
    disableCopyPaste(event) {
      if (!this.isAllowSpecialCharacters || !this.isAllowCopyAndPaste) {
        const kCode = event.keyCode || event.charCode
        if (kCode === 86 || kCode === 0) {
          this.alertInfo({ text: 'Copy and paste not allowed' })
          return false
        }
      }
    },
  },
}
</script>
